import { http } from "~/utils";
export default {
    getMasterBudget: async (page = 1, filters = {}) => {
        const request_filters = { ...filters, page };
        return http.get("/india/non-sode/master-budget/", {
                params: request_filters
            })
            .then(response => ({
                list: response.data.results,
                fields: response.data.form_filter,
                pagination: {
                    actual: response.data.actual,
                    count: response.data.count,
                    next: response.data.next,
                    pages: response.data.pages,
                    previous: response.data.previous
                }
            }));
    },
    getChoices: async (filters = {}) => {
        const request_filters = {...filters};
        return http.get("/india/non-sode/master-budget/choices/", {
            params: request_filters
        }).then(response => ({data: response.data}));
    }
};
